import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    feather_icons.replace();
  }
}
